module.exports = __webpack_public_path__ + "static/media/1009320.838f7168.png";